import axios from 'axios'
import {getApiUrls,getApiUpdateUrls} from "@/http/base.http";

export function getNetwork(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}network/get`, payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function addNetwork(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}network/add`,payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}

export function ddNetworkType() {
    const { env } = getApiUrls();
    return axios.get(`${env}dropdown/network/type/dd`).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function getByIdNetwork(id) {
    const { env } = getApiUrls();
    return axios.get(`${env}network/detail/${id}`).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function updateNetwork(payload) {
    const {envU } = getApiUpdateUrls();
    return axios.put(`${envU}network/update`,payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}